/**
 * @generated SignedSource<<1f4825db59e93418539a3e91c9dad79f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SiteNavDropdownColumn_navigationTopLevel$data = ReadonlyArray<{
  readonly items: ReadonlyArray<{
    readonly linkData: {
      readonly " $fragmentSpreads": FragmentRefs<"SeoLink_linkData">;
    };
    readonly name: string | null;
  } | null> | null;
  readonly name: string | null;
  readonly " $fragmentType": "SiteNavDropdownColumn_navigationTopLevel";
}>;
export type SiteNavDropdownColumn_navigationTopLevel$key = ReadonlyArray<{
  readonly " $data"?: SiteNavDropdownColumn_navigationTopLevel$data;
  readonly " $fragmentSpreads": FragmentRefs<"SiteNavDropdownColumn_navigationTopLevel">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SiteNavDropdownColumn_navigationTopLevel",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NavigationItem",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NavigationTopLevel",
  "abstractKey": null
};
})();

(node as any).hash = "c8a424fdf33c0d9c8c910144370274f8";

export default node;
